import { render } from "./WorksView.vue?vue&type=template&id=01d75ab1"
import script from "./WorksView.vue?vue&type=script&lang=js"
export * from "./WorksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__